<template>
  <div class="px-4 py-8 md:text-center">
    <div>
      <h2 class="mb-2 title-3">
        {{ $t.footerContent.loyalty.header }}
      </h2>
      <p class="mb-6 text-sm fw-light md:mb-4">
        {{ $t.footerContent.loyalty.description }}
      </p>
    </div>
    <vf-button
      class="c-white <md:w-full"
      :size="{ sm: 'sm', md: 'xs' }"
      :theme="ctaTheme"
      :variant="ctaTheme ? 'themable' : 'primary'"
      @click="DialogSignIn.open({ formLocation: 'modal:single:footer:none' })"
    >
      {{ $t.footerContent.loyalty.button }}
    </vf-button>
  </div>
</template>

<script lang="ts" setup>
const { DialogSignIn } = useDialogsStore()
const { ctaTheme } = useAppConfig().components.vf.footerLoyalty || {}
</script>
